import React from 'react';
import { useIntl } from 'react-intl';
import { Form } from 'semantic-ui-react';
import { globalFieldLengths } from '@/constants/fields';

const ActionDialogConfirmation = ({
  action = 'delete',
  autoFocus,
  children,
  disabled,
  entities,
  entity,
  items,
  minimumDataEntryMet,
  onChange,
  submitForm,
  text,
}) => {
  const intl = useIntl();
  const confirmLabel = () => (items.length === 1
    ? intl.formatMessage({ id: `${entity}.${action}.confirm` })
    : intl.formatMessage({ id: `${entities}.${action}.confirm` }));

  const confirmPlaceholder = () => (items.length === 1
    ? intl.formatMessage({ id: `${entity}.${action}.confirm.placeholder` })
    : intl.formatMessage({ id: `${entities}.${action}.confirm.placeholder` }));

  return (
    <Form
      autoComplete="off"
      onSubmit={minimumDataEntryMet() ? () => submitForm() : undefined}
    >
      {children}
      <Form.Input
        label={confirmLabel()}
        name="confirm_name"
        key="confirm_name"
        autoFocus={autoFocus}
        disabled={disabled}
        type="text"
        placeholder={confirmPlaceholder()}
        value={text}
        maxLength={globalFieldLengths.name}
        onChange={(e) => onChange(e.target.value)}
      />
    </Form>
  );
};

export default ActionDialogConfirmation;
